var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserRateLower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#000000",
    d: "M 43.5,-0.5 C 113.833,-0.5 184.167,-0.5 254.5,-0.5C 277.714,3.20928 292.214,16.5426 298,39.5C 298.667,112.5 298.667,185.5 298,258.5C 293.384,280.783 279.884,293.95 257.5,298C 185.167,298.667 112.833,298.667 40.5,298C 17.6542,293.654 3.9875,280.154 -0.5,257.5C -0.5,185.167 -0.5,112.833 -0.5,40.5C 5.19111,17.1405 19.8578,3.47386 43.5,-0.5 Z M 47.5,15.5 C 115.501,15.3333 183.501,15.5 251.5,16C 268.323,17.8247 278.49,26.9914 282,43.5C 282.667,114.167 282.667,184.833 282,255.5C 278.267,270.567 268.767,279.401 253.5,282C 183.833,282.667 114.167,282.667 44.5,282C 28.3333,279.167 18.8333,269.667 16,253.5C 15.3333,183.833 15.3333,114.167 16,44.5C 19.378,26.9507 29.878,17.284 47.5,15.5 Z M 212.5,208.5 C 212.5,215.5 212.5,222.5 212.5,229.5C 204.833,229.5 197.167,229.5 189.5,229.5C 201.361,226.967 209.028,219.967 212.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.761
    },
    fill: "#b97781",
    d: "M 213.5,31.5 C 213.5,97.8333 213.5,164.167 213.5,230.5C 205.316,230.174 197.316,230.508 189.5,231.5C 188.662,231.158 188.328,230.492 188.5,229.5C 188.833,229.5 189.167,229.5 189.5,229.5C 197.167,229.5 204.833,229.5 212.5,229.5C 212.5,222.5 212.5,215.5 212.5,208.5C 212.5,206.833 212.5,205.167 212.5,203.5C 212.168,145.998 212.501,88.6642 213.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd3698",
    d: "M 213.5,31.5 C 221.833,31.5 230.167,31.5 238.5,31.5C 238.5,97.8333 238.5,164.167 238.5,230.5C 246.684,230.174 254.684,230.508 262.5,231.5C 251.167,243.5 239.5,255.167 227.5,266.5C 226.167,266.167 224.833,265.833 223.5,265.5C 211.833,254.5 200.5,243.167 189.5,231.5C 197.316,230.508 205.316,230.174 213.5,230.5C 213.5,164.167 213.5,97.8333 213.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.714
    },
    fill: "#b67a80",
    d: "M 238.5,31.5 C 239.499,97.3312 239.832,163.331 239.5,229.5C 247.528,229.169 255.528,229.502 263.5,230.5C 263.376,231.107 263.043,231.44 262.5,231.5C 254.684,230.508 246.684,230.174 238.5,230.5C 238.5,164.167 238.5,97.8333 238.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#000000",
    d: "M 78.5,65.5 C 98.2016,63.3758 109.702,72.0425 113,91.5C 114.891,107.788 110.391,121.955 99.5,134C 87.9694,142.079 77.4694,140.913 68,130.5C 57.6014,115.834 54.9347,99.8339 60,82.5C 63.8575,74.1354 70.0242,68.4687 78.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.952
    },
    fill: "#f6cfe1",
    d: "M 212.5,203.5 C 212.5,205.167 212.5,206.833 212.5,208.5C 209.028,219.967 201.361,226.967 189.5,229.5C 189.167,229.5 188.833,229.5 188.5,229.5C 158.074,233.828 127.741,233.328 97.5,228C 79.8859,221.605 74.7192,209.771 82,192.5C 86.0185,186.657 90.5185,181.324 95.5,176.5C 101.087,173.581 106.42,170.248 111.5,166.5C 108.255,157.121 106.588,147.454 106.5,137.5C 110.616,108.872 126.949,96.3719 155.5,100C 171.809,105.313 181.309,116.48 184,133.5C 185.345,144.618 184.179,155.451 180.5,166C 191.942,172.776 201.442,181.609 209,192.5C 210.593,196.161 211.759,199.828 212.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 139.5,110.5 C 156.833,109.002 167.667,116.669 172,133.5C 174.391,149.062 170.891,163.062 161.5,175.5C 151.458,185.739 141.124,186.072 130.5,176.5C 119.422,162.621 115.922,146.955 120,129.5C 123.773,120.225 130.273,113.891 139.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#000000",
    d: "M 106.5,137.5 C 106.588,147.454 108.255,157.121 111.5,166.5C 106.42,170.248 101.087,173.581 95.5,176.5C 77.3575,177.239 59.3575,176.072 41.5,173C 31.6073,170.81 28.1073,164.977 31,155.5C 33.021,150.807 35.8544,146.64 39.5,143C 45.1563,137.851 51.4897,133.684 58.5,130.5C 63.8703,138.033 70.8703,143.533 79.5,147C 90.3358,148.879 99.3358,145.712 106.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 117.5,176.5 C 121.927,180.75 126.593,184.917 131.5,189C 140.821,194.997 150.154,194.997 159.5,189C 164.342,185.324 168.675,181.158 172.5,176.5C 184.741,181.523 193.908,189.857 200,201.5C 201.408,208.854 198.575,213.687 191.5,216C 183.974,218.066 176.307,219.4 168.5,220C 152.5,220.667 136.5,220.667 120.5,220C 110.603,220.023 101.436,217.523 93,212.5C 90.7552,209.119 90.0885,205.452 91,201.5C 96.9951,190.098 105.828,181.765 117.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.753
    },
    fill: "#b2837e",
    d: "M 223.5,265.5 C 224.833,265.833 226.167,266.167 227.5,266.5C 225.872,267.853 224.538,267.519 223.5,265.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRateLower);
export default __webpack_public_path__ + "static/media/User_rate_lower.5d206f730c975093d857ef72d2ed9ded.svg";
export { ForwardRef as ReactComponent };